import { Conversations } from "@/components/conversations/conversations";
import { createFileRoute, useParams } from "@tanstack/react-router";

function ConversationPage() {
  const { conversationId } = useParams({
    from: "/_authenticated/conversations/$conversationId",
  });
  return <Conversations initialSelectedConversationId={conversationId} />;
}

export const Route = createFileRoute(
  "/_authenticated/conversations/$conversationId",
)({
  component: () => <ConversationPage />,
});
